<div class="container p-0">
    <img [src]="data?.urlImagen" (error)="urlImagen = 'assets/images/logo.png'" />
</div>